import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { getSpaPathPrefix } from '../../../resources/Constants';

function EstadoCuentaPaciente() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [paciente, setPaciente] = useState(null);
    const [facturas, setFacturas] = useState([]);
    const [presupuestos, setPresupuestos] = useState([]);
    const [presupuestosActivos, setPresupuestosActivos] = useState([]);
    const [saldoTotalPresupuestos, setSaldoTotalPresupuestos] = useState(0);
    const [saldoTotal, setSaldoTotal] = useState(0);
    const [usuarios, setUsuarios] = useState([]);

    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const pacienteId = queryParams.get('id');

    // Modal Recibo de Caja
    const [showModalRecibo, setShowModalRecibo] = useState(false);
    const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
    const [valorRecibo, setValorRecibo] = useState('');
    const [medioPago, setMedioPago] = useState('10');
    const [fechaPago, setFechaPago] = useState(new Date().toISOString().split('T')[0]);
    const [observacionesRecibo, setObservacionesRecibo] = useState('');

    // Modal Nota Crédito Electrónica
    const [showModalNotaCredito, setShowModalNotaCredito] = useState(false);
    const [prefijos, setPrefijos] = useState([]);
    const [prefijoSeleccionado, setPrefijoSeleccionado] = useState('');
    const [numeroNotaCredito, setNumeroNotaCredito] = useState('');
    const [fechaNotaCredito, setFechaNotaCredito] = useState(new Date().toISOString().split('T')[0]);
    const [tipoNotaCredito, setTipoNotaCredito] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCredito, setValorNotaCredito] = useState('');
    const [motivoNotaCredito, setMotivoNotaCredito] = useState('');

    // Modal Ver Recibos
    const [showModalRecibos, setShowModalRecibos] = useState(false);
    const [recibosFactura, setRecibosFactura] = useState([]);
    const [errorFacturas, setErrorFacturas] = useState(null);

    // Modal Éxito Recibo
    const [showModalExitoRecibo, setShowModalExitoRecibo] = useState(false);
    const [reciboGuardado, setReciboGuardado] = useState(null);

    // Modal Nota Crédito No Electrónica
    const [showModalNotaCreditoNE, setShowModalNotaCreditoNE] = useState(false);
    const [tipoNotaCreditoNE, setTipoNotaCreditoNE] = useState('total'); // 'total' | 'parcial'
    const [valorNotaCreditoNE, setValorNotaCreditoNE] = useState('');
    const [motivoNotaCreditoNE, setMotivoNotaCreditoNE] = useState('');
    const [fechaNotaCreditoNE, setFechaNotaCreditoNE] = useState(new Date().toISOString().split('T')[0]);
    const [consecutivoNCNE, setConsecutivoNCNE] = useState(null); // Datos del consecutivo
    const [loadingNCNE, setLoadingNCNE] = useState(false);

    // Dropdown Nueva Factura
    const [showDropdownFactura, setShowDropdownFactura] = useState(false);

    // Modal de acciones rápidas por fila
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [tipoAccionSeleccionada, setTipoAccionSeleccionada] = useState('');
    const [registroAccion, setRegistroAccion] = useState(null);

    // Modal Debug - Para mostrar respuestas de DIAN
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState(''); // 'success', 'error'

    // Paginación
    const [paginaActualFacturas, setPaginaActualFacturas] = useState(1);
    const [paginaActualPresupuestos, setPaginaActualPresupuestos] = useState(1);
    const registrosPorPagina = 10;

    // 🔒 Función helper para validar permisos
    const tienePermiso = (permiso) => {
        const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
        return userdata.up && userdata.up.includes(permiso);
    };

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        // Verificar permisos
        const tienePermiso = userdata.up && (
            userdata.up.includes('crearPacientes') ||
            userdata.up.includes('ver_listado_facturas')
        );

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente:', error);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando usuarios:', error);
            });

        // Cargar datos del paciente
        if (pacienteId) {
            axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteId}`)
                .then(response => {
                    if (response.status === 200 && response.data.length > 0) {
                        setPaciente(response.data[0]);
                    }
                })
                .catch(error => {
                    console.log('Error cargando paciente:', error);
                });

            // Cargar facturas del paciente usando el nuevo endpoint
            axios.get(`/facturas/paciente/${pacienteId}`)
                .then(response => {
                    if (response.status === 200) {
                        setFacturas(response.data);

                        // Calcular saldo total pendiente (usar == para comparar con strings/numbers)
                        const saldo = response.data
                            .filter(f => f.estado == 2 || f.estado == 5)
                            .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                        setSaldoTotal(saldo);
                    }
                })
                .catch(error => {
                    console.log('Error cargando facturas:', error);
                    if (error.response && error.response.status === 403) {
                        setErrorFacturas('No tienes permiso para ver facturas. Contacta al administrador para obtener el permiso "ver_listado_facturas".');
                    } else if (error.response && error.response.status === 401) {
                        setErrorFacturas('Sesión expirada. Por favor inicia sesión nuevamente.');
                    }
                });

            // Cargar presupuestos del paciente usando el nuevo endpoint
            axios.get(`/presupuestos/paciente/${pacienteId}?uid=${userdata.user_id}`)
                .then(response => {
                    if (response.status === 200) {
                        setPresupuestos(response.data);
                    }
                })
                .catch(error => {
                    console.log('Error cargando presupuestos:', error);
                });

            // Cargar presupuestos activos del paciente
            axios.get(`/presupuestos/paciente/${pacienteId}/activos`)
                .then(response => {
                    if (response.status === 200) {
                        setPresupuestosActivos(response.data.presupuestos || []);
                        setSaldoTotalPresupuestos(parseFloat(response.data.total_saldo_disponible || 0));
                    }
                })
                .catch(error => {
                    console.log('Error cargando presupuestos activos:', error);
                });
        }
    }, [pacienteId]);

    const getNombreCompleto = () => {
        if (!paciente) return '';
        return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'estado-chip generado';
            case 1: return 'estado-chip activo';
            case 2: return 'estado-chip por-cobrar';
            case 3: return 'estado-chip anulado';
            case 4: return 'estado-chip activo';
            case 5: return 'estado-chip por-cobrar';
            case 6: return 'estado-chip error';
            default: return 'estado-chip generado';
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO');
    };

    const crearFactura = () => {
        history.push(`/crear-factura?paciente_id=${pacienteId}`);
    };

    const crearPresupuesto = () => {
        history.push(`/crear-presupuesto?paciente_id=${pacienteId}`);
    };

    const vistaPreviaPresupuesto = (presupuestoId) => {
        const prefix = getSpaPathPrefix();
        window.open(`${window.location.origin}${prefix}/#/vista-previa-presupuesto/${presupuestoId}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const cambiarEstadoPresupuesto = async (presupuestoId, nuevoEstado) => {
        const mensajes = { 1: '¿Aprobar este presupuesto?', 2: '¿Está seguro de ANULAR este presupuesto? El saldo se pondrá en $0.' };
        if (!window.confirm(mensajes[nuevoEstado] || '¿Cambiar estado?')) return;
        try {
            const response = await axios.put(`/presupuesto/${presupuestoId}/estado`, { estado: nuevoEstado });
            if (response.data.success) {
                // Recargar presupuestos
                const userdata = JSON.parse(localStorage.getItem('userdata'));
                const [presResp, activosResp] = await Promise.all([
                    axios.get(`/presupuestos/paciente/${pacienteId}?uid=${userdata.user_id}`),
                    axios.get(`/presupuestos/paciente/${pacienteId}/activos`)
                ]);
                if (presResp.status === 200) setPresupuestos(presResp.data);
                if (activosResp.status === 200) {
                    setPresupuestosActivos(activosResp.data.presupuestos || []);
                    setSaldoTotalPresupuestos(parseFloat(activosResp.data.total_saldo_disponible || 0));
                }
            }
        } catch (error) {
            alert('Error: ' + (error.response?.data?.message || error.message));
        }
    };

    // ==========================================
    // Funciones de ListadoFacturas
    // ==========================================

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id == usuarioId); // Usar == en lugar de === para comparación flexible
        return usuario ? usuario.name : 'N/A';
    };

    const abrirModalRecibo = (factura) => {
        setFacturaSeleccionada(factura);
        setValorRecibo(0);
        setMedioPago('10');
        setFechaPago(new Date().toISOString().split('T')[0]);
        setObservacionesRecibo('');
        setShowModalRecibo(true);
    };

    const guardarRecibo = async () => {
        const valorPendiente = facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total;

        if (!valorRecibo || parseFloat(valorRecibo) <= 0) {
            alert('Ingrese un valor válido');
            return;
        }

        if (parseFloat(valorRecibo) > parseFloat(valorPendiente)) {
            alert(`El valor no puede ser mayor al saldo pendiente: ${Math.round(parseFloat(valorPendiente)).toLocaleString('es-CO')}`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const reciboData = {
            factura_id: facturaSeleccionada.id,
            valor_recibido: parseFloat(valorRecibo),
            medio_pago: medioPago,
            fecha_pago: fechaPago,
            observaciones: observacionesRecibo
        };

        try {
            const response = await axios.post('/recibo-caja', reciboData);
            if (response.status === 200 || response.status === 201) {
                setShowModalRecibo(false);
                setReciboGuardado(response.data);
                setShowModalExitoRecibo(true);
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            }
        } catch (error) {
            alert('Error al registrar el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const vistaPrevia = (facturaId) => {
        const url = `${window.location.origin}/smile/#/vista-previa-factura/${facturaId}`;
        window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const abrirModalNotaCredito = async (factura) => {
        setFacturaSeleccionada(factura);
        setPrefijoSeleccionado('');
        setNumeroNotaCredito('');
        setTipoNotaCredito('total');
        setValorNotaCredito('');
        setMotivoNotaCredito('');

        // Cargar prefijos filtrados por tipo NC y usuario de la factura
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.get('/parametros-fev?uid=' + userdata.user_id);
            if (response.status === 200) {
                const prefijosFiltrados = response.data.filter(param =>
                    param.tipo === 'Nota Credito' &&
                    param.users_id == factura.users_id &&
                    param.habilitado == 1
                );
                setPrefijos(prefijosFiltrados);
            }
        } catch (error) {
            console.log('Error cargando prefijos: ' + error);
        }

        setShowModalNotaCredito(true);
    };

    const handlePrefijoChange = (e) => {
        const prefijoId = e.target.value;
        setPrefijoSeleccionado(prefijoId);

        if (prefijoId) {
            const prefijo = prefijos.find(p => p.id == prefijoId);
            if (prefijo) {
                setNumeroNotaCredito(prefijo.numero_factura);
            }
        } else {
            setNumeroNotaCredito('');
        }
    };

    const anularFactura = async (facturaId, facturaActual = null) => {
        const factura = facturaActual || facturas.find(f => f.id === facturaId);

        if (!factura) {
            alert('No se ha seleccionado ninguna factura');
            return;
        }

        // Mensaje diferente según el estado
        let mensaje = '¿Está seguro de anular esta factura?';
        if (factura.estado === 4) {
            mensaje = '¿Está seguro de anular esta factura de contado? Se generará una Nota Crédito automática para trazabilidad.';
        }

        if (!window.confirm(mensaje)) {
            return;
        }

        try {
            let response;

            if (factura.estado === 4) {
                // Estado 4: Usar endpoint especial que genera NC automática
                response = await axios.post('/anular-factura-contado', {
                    factura_id: facturaId
                });
            } else {
                // Otros estados: Anulación directa
                response = await axios.put(`/factura/${facturaId}/estado`, { estado: 3 });
            }

            if (response.status === 200 || response.data.success) {
                alert(response.data.message || 'Factura anulada exitosamente');
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            }
        } catch (error) {
            alert('Error al anular la factura: ' + (error.response?.data?.message || error.message));
        }
    };

    const generarNotaCredito = async () => {
        if (!prefijoSeleccionado) {
            alert('Seleccione un prefijo');
            return;
        }

        if (!fechaNotaCredito) {
            alert('Seleccione una fecha');
            return;
        }

        if (!motivoNotaCredito.trim()) {
            alert('Ingrese el motivo de la nota crédito');
            return;
        }

        // Validar valor si es parcial
        if (tipoNotaCredito === 'parcial') {
            const valor = parseFloat(valorNotaCredito);
            const saldoPendiente = parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total);

            if (!valorNotaCredito || valor <= 0) {
                alert('Ingrese un valor válido para la nota crédito');
                return;
            }

            if (valor > saldoPendiente) {
                alert(`El valor no puede ser mayor al saldo pendiente: ${Math.round(saldoPendiente).toLocaleString('es-CO')}`);
                return;
            }
        }

        const mensajeConfirmacion = tipoNotaCredito === 'total'
            ? '¿Está seguro de generar una Nota Crédito TOTAL? Esta acción no se puede deshacer.'
            : `¿Está seguro de generar una Nota Crédito PARCIAL por ${Math.round(parseFloat(valorNotaCredito)).toLocaleString('es-CO')}? Esta acción no se puede deshacer.`;

        if (!window.confirm(mensajeConfirmacion)) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const notaCreditoData = {
            factura_id: facturaSeleccionada.id,
            parametrosfev_id: prefijoSeleccionado,
            motivo: motivoNotaCredito,
            fecha_emision: fechaNotaCredito,
            tipo: tipoNotaCredito,
            valor: tipoNotaCredito === 'parcial' ? parseFloat(valorNotaCredito) : null
        };

        try {
            const response = await axios.post('/nota-credito/enviar-dian-directo', notaCreditoData);

            setShowModalNotaCredito(false);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: response.data.message,
                    uuid: response.data.uuid,
                    numero_nc: response.data.numero_nc,
                    recibos_anulados: response.data.recibos_anulados,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    facturaId: facturaSeleccionada.id
                });
                setShowModalDebug(true);
            }

            // Recargar facturas
            const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
            if (facturaResponse.status === 200) {
                setFacturas(facturaResponse.data);
                const saldo = facturaResponse.data
                    .filter(f => f.estado === 2 || f.estado === 5)
                    .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                setSaldoTotal(saldo);
            }

            setPrefijoSeleccionado('');
            setNumeroNotaCredito('');
            setFechaNotaCredito(new Date().toISOString().split('T')[0]);
            setTipoNotaCredito('total');
            setValorNotaCredito('');
            setMotivoNotaCredito('');

        } catch (error) {
            console.error('Error al generar nota crédito:', error);
            setShowModalNotaCredito(false);

            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                facturaId: facturaSeleccionada.id
            });
            setShowModalDebug(true);
        }
    };

    const verRecibos = async (factura) => {
        setFacturaSeleccionada(factura);

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.get(`/recibos-caja/${factura.id}?uid=${userdata.user_id}`);
            if (response.status === 200) {
                setRecibosFactura(response.data);
                setShowModalRecibos(true);
            }
        } catch (error) {
            alert('Error al cargar los recibos: ' + (error.response?.data?.message || error.message));
        }
    };

    const getMedioPagoTexto = (codigo) => {
        const mediosPago = {
            '10': 'Efectivo',
            '42': 'Consignación bancaria',
            '1': 'Instrumento no definido',
            '20': 'Cheque',
            '30': 'Transferencia Crédito',
            '31': 'Transferencia Débito',
            '45': 'Transferencia Crédito Bancario',
            '47': 'Transferencia Débito Bancaria',
            '48': 'Tarjeta Crédito',
            '49': 'Tarjeta Débito',
            'ZZZ': 'Acuerdo mutuo'
        };
        return mediosPago[codigo] || codigo;
    };

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor)).toLocaleString('es-CO');
    };

    const anularRecibo = async (reciboId) => {
        if (!window.confirm('¿Está seguro de anular este recibo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        // Mantener el estado actual según el tipo de factura
        // Estado 2: Por Cobrar (Electrónica) - mantener en 2
        // Estado 5: Por Cobrar (No Electrónica) - mantener en 5
        const estadoDestino = facturaSeleccionada.estado === 5 ? 5 : 2;

        try {
            const response = await axios.put(`/recibo-caja/${reciboId}/anular?uid=${userdata.user_id}`,
                { estado_factura_destino: estadoDestino }
            );
            if (response.status === 200) {
                alert('Recibo anulado exitosamente');
                verRecibos(facturaSeleccionada);
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            }
        } catch (error) {
            alert('Error al anular el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const vistaPreviaRecibo = async (recibo) => {
        let pacienteData = paciente;

        // Cargar datos completos del paciente si es necesario
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${paciente?.id}`);
            if (response.data && response.data.length > 0) {
                pacienteData = response.data[0];
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = pacienteData ? `${pacienteData.primer_nombre || ''} ${pacienteData.segundo_nombre || ''} ${pacienteData.primer_apellido || ''} ${pacienteData.segundo_apellido || ''}`.trim() : getNombreCompleto();

        // Obtener nombre del facturador
        const nombreFacturador = facturaSeleccionada?.users_id ? getNombreUsuario(facturaSeleccionada.users_id) : 'N/A';

        // BANNER: RECIBO DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBO DE CAJA - FACTURA N° ${facturaSeleccionada?.numero_factura || ''}
                </div>
            </div>
        `;

        // Datos del recibo en tabla
        const datosReciboHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">RECIBO #</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${recibo.numero_recibo}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA PAGO</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(recibo.fecha_pago)}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FORMA DE PAGO</td>
                        <td style="background-color: #ffffff; width: 19%; padding: 6px; border: 1px solid #dee2e6;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td colspan="5" style="background-color: #ffffff; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibo = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${bannerHTML}
                    
                    ${datosReciboHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit()}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${pacienteData ? (pacienteData.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${pacienteData ? (pacienteData.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${pacienteData ? (pacienteData.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(pacienteData)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Concepto</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px; background-color: #ffffff; font-size: 12px;">Abono a Factura N° ${facturaSeleccionada?.numero_factura || ''}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; background-color: #ffffff; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif; white-space: nowrap;">Total:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    ${recibo.observaciones ? `
                    <div style="margin-top: 20px;">
                        <h6 style="font-size: 14px; font-weight: bold;">Observaciones:</h6>
                        <p style="font-size: 12px;">${recibo.observaciones}</p>
                    </div>
                    ` : ''}

                    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px;">
                        <p style="color: #666; margin-bottom: 30px; font-size: 12px;">Recibí conforme el valor arriba mencionado</p>
                        <div style="margin-top: 50px;">
                            <div style="border-top: 1px solid #333; width: 200px; margin: 0 auto;"></div>
                            <p style="margin-top: 5px; color: #666; font-size: 12px;">Firma del Paciente</p>
                        </div>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibo de Caja N° ${recibo.numero_recibo}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibo}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const construirDireccionCompleta = (paciente) => {
        if (!paciente) return '';
        const partes = [];
        if (paciente.direccion) partes.push(paciente.direccion);
        if (paciente.zona) partes.push(paciente.zona);
        if (paciente.nombre_ciudad_residencia) partes.push(paciente.nombre_ciudad_residencia);
        if (paciente.nombre_departamento_residencia) partes.push(paciente.nombre_departamento_residencia);
        if (paciente.nombre_pais_residencia) partes.push(paciente.nombre_pais_residencia);
        return partes.join(', ') || paciente.direccion || '';
    };

    const obtenerNit = () => {
        if (client?.numero_documento) {
            return client.digito_verificacion
                ? `${client.numero_documento}-${client.digito_verificacion}`
                : client.numero_documento;
        }
        return '';
    };

    const abrirModalAcciones = (tipo, registro) => {
        setTipoAccionSeleccionada(tipo);
        setRegistroAccion(registro);
        setShowModalAcciones(true);
    };

    const cerrarModalAcciones = () => {
        setShowModalAcciones(false);
        setTipoAccionSeleccionada('');
        setRegistroAccion(null);
    };

    const reenviarFacturaDian = async (facturaId) => {
        if (!window.confirm('¿Está seguro de reintentar el envío de esta factura a la DIAN?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        try {
            const response = await axios.post(`/factura/${facturaId}/enviar-dian`, {});

            console.log('Respuesta completa de enviar-dian:', response.data);

            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Factura enviada exitosamente a la DIAN',
                    uuid: response.data.uuid,
                    estado: response.data.estado,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message || 'Error al enviar a la DIAN',
                    response: response.data.response || response.data.error,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    fullError: response.data,
                    facturaId: facturaId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN (catch):', error);

            const errorData = {
                message: error.response?.data?.message || error.message || 'Error al enviar a la DIAN',
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                status_code: error.response?.status || error.response?.data?.status_code,
                fullError: error.response?.data || error,
                facturaId: facturaId
            };

            setDebugType('error');
            setDebugData(errorData);
            setShowModalDebug(true);
        }
    };

    const abrirModalNotaCreditoNoElectronica = async (factura) => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        setFacturaSeleccionada(factura);
        setLoadingNCNE(true);

        try {
            const response = await axios.get('/consecutivo-nc-no-electronica?uid=' + userdata.user_id);
            if (response.data) {
                setConsecutivoNCNE(response.data);

                // Inicializar formulario
                setTipoNotaCreditoNE('total');
                // Valor por defecto: el pendiente (o total si no hay pagos)
                const saldo = parseFloat(factura.valor_pendiente || factura.valor_total);
                setValorNotaCreditoNE(saldo);
                setMotivoNotaCreditoNE('');
                setFechaNotaCreditoNE(new Date().toISOString().split('T')[0]);

                setShowModalNotaCreditoNE(true);
            } else {
                alert('No se ha configurado un consecutivo para Notas Crédito No Electrónicas. Vaya a Configuración > Administrador Contable.');
            }
        } catch (error) {
            console.error(error);
            alert('Error al obtener consecutivo de Notas Crédito.');
        } finally {
            setLoadingNCNE(false);
        }
    };

    const generarNotaCreditoNE = async (e) => {
        e.preventDefault();

        if (!facturaSeleccionada || !consecutivoNCNE) return;

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const saldoPendiente = parseFloat(facturaSeleccionada.valor_pendiente || facturaSeleccionada.valor_total);
        const valorAplicar = parseFloat(valorNotaCreditoNE);

        // Validaciones
        if (valorAplicar <= 0) {
            alert("El valor de la nota crédito debe ser mayor a 0.");
            return;
        }

        if (valorAplicar > saldoPendiente + 100) { // Tolerancia pequeña por redondeo
            alert(`El valor de la nota crédito (${valorAplicar.toLocaleString()}) no puede superar el saldo pendiente de la factura (${saldoPendiente.toLocaleString()}).`);
            return;
        }

        if (!motivoNotaCreditoNE.trim()) {
            alert("Debe ingresar un motivo para la nota crédito.");
            return;
        }

        if (!window.confirm(`¿Está seguro de generar una Nota Crédito por valor de ${valorAplicar.toLocaleString()}? Esta acción afectará el saldo y el consecutivo.`)) {
            return;
        }

        const data = {
            factura_id: facturaSeleccionada.id,
            valor: valorAplicar,
            motivo: motivoNotaCreditoNE,
            fecha: fechaNotaCreditoNE,
            consecutivo_id: consecutivoNCNE.id,
            tipo_nota: tipoNotaCreditoNE // 'total' o 'parcial'
        };

        setLoadingNCNE(true);

        try {
            const response = await axios.post('/nota-credito-no-electronica?uid=' + userdata.user_id, data);

            if (response.data.success) {
                alert('Nota Crédito generada exitosamente: ' + response.data.numero_nota);
                setShowModalNotaCreditoNE(false);
                // Recargar facturas
                const facturaResponse = await axios.get(`/facturas/paciente/${pacienteId}`);
                if (facturaResponse.status === 200) {
                    setFacturas(facturaResponse.data);
                    const saldo = facturaResponse.data
                        .filter(f => f.estado === 2 || f.estado === 5)
                        .reduce((sum, f) => sum + parseFloat(f.valor_pendiente || f.valor_total || 0), 0);
                    setSaldoTotal(saldo);
                }
            } else {
                alert('Error al generar: ' + JSON.stringify(response.data));
            }

        } catch (error) {
            console.error(error);
            alert('Error al generar la Nota Crédito: ' + (error.response?.data?.message || error.message));
        } finally {
            setLoadingNCNE(false);
        }
    };

    // ==========================================
    // Funciones de Paginación
    // ==========================================

    // Calcular facturas paginadas
    const indiceUltimoRegistroFacturas = paginaActualFacturas * registrosPorPagina;
    const indicePrimerRegistroFacturas = indiceUltimoRegistroFacturas - registrosPorPagina;
    const facturasPaginadas = facturas.slice(indicePrimerRegistroFacturas, indiceUltimoRegistroFacturas);
    const totalPaginasFacturas = Math.ceil(facturas.length / registrosPorPagina);

    const cambiarPaginaFacturas = (numeroPagina) => {
        setPaginaActualFacturas(numeroPagina);
    };

    // Calcular presupuestos paginados
    const indiceUltimoRegistroPresupuestos = paginaActualPresupuestos * registrosPorPagina;
    const indicePrimerRegistroPresupuestos = indiceUltimoRegistroPresupuestos - registrosPorPagina;
    const presupuestosPaginados = presupuestos.slice(indicePrimerRegistroPresupuestos, indiceUltimoRegistroPresupuestos);
    const totalPaginasPresupuestos = Math.ceil(presupuestos.length / registrosPorPagina);

    const cambiarPaginaPresupuestos = (numeroPagina) => {
        setPaginaActualPresupuestos(numeroPagina);
    };

    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (
            <div className="hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .info-card {
                        background: white;
                        border: 1px solid #dee2e6;
                        border-radius: 8px;
                        padding: 16px;
                        margin-bottom: 20px;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                        height: 100%;
                    }
                    .info-card h5 {
                        color: #495057;
                        margin-bottom: 10px;
                        font-weight: 600;
                        border-bottom: 2px solid #17a2b8;
                        padding-bottom: 8px;
                        font-size: 1.05rem;
                    }
                    .info-card p {
                        margin-bottom: 6px;
                        font-size: 0.82rem;
                        color: #495057;
                    }
                    .info-card strong {
                        color: #212529;
                        font-size: 0.84rem;
                    }
                    .nombre-paciente-highlight {
                        color: #17a2b8;
                        font-weight: 700;
                    }
                    .estado-cuenta-title {
                        font-size: 2rem;
                    }
                    .saldo-card {
                        background: white;
                        border: 1px solid #dee2e6;
                        border-radius: 8px;
                        padding: 14px;
                        margin-bottom: 12px;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                        height: 100%;
                    }
                    .saldo-card h5 {
                        color: #495057;
                        margin-bottom: 10px;
                        font-weight: 600;
                        border-bottom: 2px solid #17a2b8;
                        padding-bottom: 8px;
                        font-size: 0.95rem;
                    }
                    .saldo-card h2 {
                        font-size: 1.75rem;
                        font-weight: 700;
                        margin: 10px 0;
                    }
                    .saldo-principal h2 { color: #17a2b8; }
                    .saldo-secundario h2 { color: ${saldoTotal > 0 ? '#dc3545' : '#28a745'}; }
                    .saldo-card p {
                        color: #6c757d;
                        margin-bottom: 0;
                        font-size: 0.78rem;
                    }
                    .custom-table {
                        width: 100%;
                        background: #fff;
                        table-layout: fixed;
                        min-width: 980px;
                    }
                    .custom-table thead th {
                        background: #f8f9fa; color: #7d7d7d !important; text-transform: uppercase;
                        font-size: 0.68rem !important; font-weight: 700 !important; padding: 11px 14px !important; border: none !important;
                    }
                    .custom-table tbody tr { border-bottom: 1px solid #f0f0f0; transition: all 0.2s; }
                    .custom-table tbody tr:hover { background-color: #f9fbff !important; box-shadow: inset 4px 0 0 #17a2b8; }
                    .custom-table td {
                        padding: 9px 14px !important;
                        vertical-align: middle !important;
                        border: none !important;
                        font-size: 0.8rem !important;
                        white-space: nowrap;
                    }
                    .resumen-pill {
                        display: inline-flex;
                        align-items: center;
                        padding: 4px 10px;
                        border-radius: 999px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        color: #0f766e;
                        background: #ecfeff;
                        border: 1px solid #99f6e4;
                    }
                    .estado-chip {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 3px 10px;
                        border-radius: 999px;
                        font-size: 0.68rem;
                        font-weight: 700;
                        border: 1px solid transparent;
                        line-height: 1.2;
                    }
                    .estado-chip.generado { color: #6b7280; background: #f3f4f6; border-color: #d1d5db; }
                    .estado-chip.activo { color: #047857; background: #ecfdf5; border-color: #a7f3d0; }
                    .estado-chip.por-cobrar { color: #b45309; background: #fffbeb; border-color: #fde68a; }
                    .estado-chip.anulado { color: #b91c1c; background: #fef2f2; border-color: #fecaca; }
                    .estado-chip.error { color: #b91c1c; background: #fef2f2; border-color: #fecaca; }
                    .tipo-chip {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 3px 8px;
                        border-radius: 999px;
                        font-size: 0.67rem;
                        font-weight: 700;
                    }
                    .tipo-chip.elect { color: #0f766e; background: #ecfeff; border: 1px solid #99f6e4; }
                    .tipo-chip.no-elect { color: #374151; background: #f3f4f6; border: 1px solid #d1d5db; }
                    .badge-outline-secondary {
                        color: #6c757d;
                        border: 1px solid #6c757d;
                        background-color: transparent;
                    }
                    .badge-outline-success {
                        color: #28a745;
                        border: 1px solid #28a745;
                        background-color: transparent;
                    }
                    .badge-outline-warning {
                        color: #ffc107;
                        border: 1px solid #ffc107;
                        background-color: transparent;
                    }
                    .badge-outline-danger {
                        color: #dc3545;
                        border: 1px solid #dc3545;
                        background-color: transparent;
                    }
                    .badge-outline-info {
                        color: #17a2b8;
                        border: 1px solid #17a2b8;
                        background-color: transparent;
                    }
                    .btn-toolbar {
                        gap: 0.5rem;
                    }
                    .card-header.bg-gradient-light {
                        background: linear-gradient(135deg, #f6fcfd 0%, #e6f7f9 100%);
                        border-bottom: 2px solid #17a2b8;
                    }
                    .shadow-sm {
                        box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.1) !important;
                    }
                    .action-buttons { display: flex; flex-wrap: wrap; gap: 8px; }
                    .action-buttons .btn { border-radius: 10px; }
                    .card-primary.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .card-info.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .pagination .page-item.active .page-link {
                        background-color: #282828;
                        border-color: #282828;
                        color: #f6fcfd;
                    }
                    .pagination .page-link {
                        color: #282828;
                        border-color: #dee2e6;
                    }
                    .pagination .page-link:hover {
                        background-color: #f6fcfd;
                        border-color: #17a2b8;
                        color: #282828;
                    }
                    .pagination .page-item.disabled .page-link {
                        color: #6c757d;
                        background-color: #fff;
                        border-color: #dee2e6;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-pacientes">Pacientes</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listar-pacientes">Listar Pacientes</Link></li>
                                        <li className="breadcrumb-item active">Estado de Cuenta</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0 estado-cuenta-title">
                                        Estado de Cuenta - <span className="nombre-paciente-highlight">{getNombreCompleto()}</span>
                                    </h1>
                                </div>
                                <div className="col-sm-4 text-right">
                                    <Link to="/listar-pacientes" className="btn btn-secondary">
                                        <i className="fas fa-arrow-left"></i> Volver
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">

                            {/* Información del Paciente + Saldos */}
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="info-card">
                                        <h5><i className="fas fa-user"></i> Información del Paciente</h5>
                                        <div className="mt-3">
                                            <p><strong>Documento:</strong> {paciente?.numero_documento || 'N/A'}</p>
                                            <p><strong>Teléfono:</strong> {paciente?.telefono || 'N/A'}</p>
                                            <p><strong>Celular:</strong> {paciente?.celular || 'N/A'}</p>
                                            <p><strong>Email:</strong> {paciente?.email || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-7">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="saldo-card saldo-principal">
                                                <h5><i className="fas fa-wallet"></i> Saldo Presupuestos</h5>
                                                <h2>${Math.round(saldoTotalPresupuestos).toLocaleString('es-CO')}</h2>
                                                <p>Control Principal de Tratamientos Activos</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="saldo-card saldo-secundario">
                                                <h5><i className="fas fa-file-invoice-dollar"></i> Saldo Facturas a Crédito</h5>
                                                <h2>${Math.round(saldoTotal).toLocaleString('es-CO')}</h2>
                                                <p>Saldo por Cancelar con Recibos de Caja</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="alert alert-light border mt-2 mb-3" role="alert" style={{ fontSize: '0.86rem' }}>
                                        <div><strong>Saldo Presupuestos:</strong> Se cruza contra facturas y es la referencia principal de control clínico/administrativo.</div>
                                        <div><strong>Saldo Facturas a Crédito:</strong> Se recauda con recibos de caja; puede no coincidir con el saldo de presupuestos según la operación del cliente.</div>
                                    </div>
                                    {errorFacturas && (
                                        <div className="alert alert-warning mt-2" role="alert">
                                            <i className="fas fa-exclamation-triangle mr-1"></i> {errorFacturas}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Botones de Acción */}
                            <div className="row mt-2 mb-3">
                                <div className="col-md-12">
                                    <div className="action-buttons" role="group">
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-success dropdown-toggle"
                                                type="button"
                                                onClick={() => setShowDropdownFactura(!showDropdownFactura)}
                                            >
                                                <i className="fas fa-plus"></i> Nueva Factura
                                            </button>
                                            {showDropdownFactura && (
                                                <div className="dropdown-menu show" style={{ position: 'absolute', left: 0 }}>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            setShowDropdownFactura(false);
                                                            crearFactura();
                                                        }}
                                                    >
                                                        <i className="fas fa-plus"></i> Electrónica
                                                    </button>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            setShowDropdownFactura(false);
                                                            history.push(`/crear-factura-no-electronica?paciente_id=${pacienteId}`);
                                                        }}
                                                    >
                                                        <i className="fas fa-plus"></i> No Electrónica
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        <button className="btn btn-info" onClick={crearPresupuesto}>
                                            <i className="fas fa-calculator"></i> Nuevo Presupuesto
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Sección Presupuestos Activos */}
                            <div className="card" style={{ borderColor: '#17a2b8', borderWidth: '1px', borderStyle: 'solid' }}>
                                <div className="card-header" style={{ backgroundColor: '#d1ecf1', borderBottom: '1px solid #17a2b8' }}>
                                    <h3 className="card-title" style={{ color: '#0c5460' }}>
                                        <i className="fas fa-wallet mr-2"></i> Presupuestos Activos
                                        {presupuestosActivos.length > 0 && (
                                            <span className="resumen-pill ml-2">
                                                Saldo Presupuestos: ${Math.round(saldoTotalPresupuestos).toLocaleString('es-CO')}
                                            </span>
                                        )}
                                    </h3>
                                </div>

                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    {presupuestos.filter(p => p.estado === 1 || p.estado === 2).length === 0 ? (
                                        <div className="text-center p-4">
                                            <i className="fas fa-info-circle text-muted mr-1"></i>
                                            <span className="text-muted">No hay presupuestos de saldo registrados</span>
                                        </div>
                                    ) : (
                                        <table className="table custom-table mb-0">
                                            <colgroup>
                                                <col style={{ width: '18%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '14%' }} />
                                                <col style={{ width: '14%' }} />
                                                <col style={{ width: '16%' }} />
                                                <col style={{ width: '14%' }} />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>N° Presupuesto</th>
                                                    <th>Fecha</th>
                                                    <th className="text-right">Total</th>
                                                    <th className="text-right">Pagado</th>
                                                    <th className="text-right">Pendiente</th>
                                                    <th className="text-center">Estado</th>
                                                    <th className="text-center">Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {presupuestos.filter(p => p.estado === 1 || p.estado === 2).map(pres => {
                                                    const esActivo = parseInt(pres.estado) === 1;
                                                    const valorTotal = parseFloat(pres.valor_total || 0);
                                                    const valorPagado = parseFloat(pres.valor_consumido || 0);
                                                    const saldoPendiente = parseFloat(pres.saldo_disponible || 0);
                                                    const valorAnulado = esActivo ? 0 : (valorTotal - valorPagado);
                                                    return (
                                                        <tr key={pres.id}>
                                                            <td><strong>{pres.numero_presupuesto}</strong></td>
                                                            <td>{formatearFecha(pres.fecha_creacion)}</td>
                                                            <td className="text-right">${Math.round(valorTotal).toLocaleString('es-CO')}</td>
                                                            <td className="text-right" style={{ color: '#28a745', fontWeight: 'bold' }}>${Math.round(valorPagado).toLocaleString('es-CO')}</td>
                                                            <td className="text-right">
                                                                {esActivo ? (
                                                                    <strong style={{ color: saldoPendiente > 0 ? '#dc3545' : '#28a745' }}>
                                                                        ${Math.round(saldoPendiente).toLocaleString('es-CO')}
                                                                    </strong>
                                                                ) : (
                                                                    <span style={{ color: '#6c757d' }}>${Math.round(valorAnulado).toLocaleString('es-CO')}</span>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={`estado-chip ${esActivo ? 'activo' : 'anulado'}`}>
                                                                    {esActivo ? 'Activo' : 'Anulado'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light shadow-sm"
                                                                    onClick={() => abrirModalAcciones('presupuesto', pres)}
                                                                    style={{ borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0' }}
                                                                >
                                                                    <i className="fas fa-ellipsis-v"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>

                            {/* Tabla de Facturas Generadas */}
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h3 className="card-title"><i className="fas fa-file-invoice-dollar"></i> Facturas Generadas</h3>
                                </div>
                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    <table className="table custom-table mb-0">
                                        <colgroup>
                                            <col style={{ width: '18%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '14%' }} />
                                            <col style={{ width: '14%' }} />
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '14%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>N° Factura</th>
                                                <th>Fecha</th>
                                                <th className="text-center">Total</th>
                                                <th className="text-center">Pendiente</th>
                                                <th className="text-center">Tipo</th>
                                                <th className="text-center">Estado</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {facturasPaginadas.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center">No hay facturas registradas</td>
                                                </tr>
                                            ) : (
                                                facturasPaginadas.map(factura => (
                                                    <tr key={factura.id}>
                                                        <td>
                                                            {factura.prefijo && factura.numero_factura ? (
                                                                <strong>{factura.prefijo}-{factura.numero_factura}</strong>
                                                            ) : factura.numero_factura ? (
                                                                <strong>{factura.numero_factura}</strong>
                                                            ) : (
                                                                <strong className="text-muted">#{factura.id}</strong>
                                                            )}
                                                        </td>

                                                        <td>{formatearFecha(factura.fecha_emision)}</td>
                                                        <td className="text-center">
                                                            <strong>${Math.round(parseFloat(factura.valor_total)).toLocaleString('es-CO')}</strong>
                                                        </td>
                                                        <td className="text-center">
                                                            {(factura.estado === 2 || factura.estado === 5) ? (
                                                                <span className="text-danger font-weight-bold">
                                                                    ${Math.round(parseFloat(factura.valor_pendiente || factura.valor_total)).toLocaleString('es-CO')}
                                                                </span>
                                                            ) : (
                                                                <span className="text-success">$0</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`tipo-chip ${[4, 5].includes(factura.estado) ? 'no-elect' : 'elect'}`}>
                                                                {[4, 5].includes(factura.estado) ? 'No Elect.' : 'Elect.'}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={getEstadoColor(factura.estado)}>
                                                                {getEstadoTexto(factura.estado)}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-light shadow-sm"
                                                                onClick={() => abrirModalAcciones('factura', factura)}
                                                                style={{ borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0' }}
                                                            >
                                                                <i className="fas fa-ellipsis-v"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginador Facturas */}
                                {facturas.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {indicePrimerRegistroFacturas + 1} a {Math.min(indiceUltimoRegistroFacturas, facturas.length)} de {facturas.length} facturas
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActualFacturas === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaFacturas(paginaActualFacturas - 1)}
                                                            disabled={paginaActualFacturas === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPaginasFacturas)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        // Mostrar solo 5 páginas a la vez
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginasFacturas ||
                                                            (numeroPagina >= paginaActualFacturas - 1 && numeroPagina <= paginaActualFacturas + 1)
                                                        ) {
                                                            return (
                                                                <li
                                                                    key={numeroPagina}
                                                                    className={`page-item ${paginaActualFacturas === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => cambiarPaginaFacturas(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActualFacturas - 2 ||
                                                            numeroPagina === paginaActualFacturas + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}

                                                    <li className={`page-item ${paginaActualFacturas === totalPaginasFacturas ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaFacturas(paginaActualFacturas + 1)}
                                                            disabled={paginaActualFacturas === totalPaginasFacturas}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Tabla de Presupuestos del Paciente */}
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h3 className="card-title"><i className="fas fa-calculator"></i> Presupuestos del Paciente</h3>
                                </div>

                                <div className="card-body p-0" style={{ overflowX: 'auto' }}>
                                    <table className="table custom-table mb-0">
                                        <colgroup>
                                            <col style={{ width: '18%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '12%' }} />
                                            <col style={{ width: '14%' }} />
                                            <col style={{ width: '14%' }} />
                                            <col style={{ width: '16%' }} />
                                            <col style={{ width: '14%' }} />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>N° Presupuesto</th>
                                                <th>Fecha</th>
                                                <th className="text-center">Total</th>
                                                <th className="text-center">Pagado</th>
                                                <th className="text-center">Pendiente</th>
                                                <th className="text-center">Estado</th>
                                                <th className="text-center">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {presupuestosPaginados.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center">No hay presupuestos registrados</td>
                                                </tr>
                                            ) : (
                                                presupuestosPaginados.map(presupuesto => {
                                                    const estado = parseInt(presupuesto.estado);
                                                    const estadoTextos = { 0: 'Generado', 1: 'Activo', 2: 'Anulado', 3: 'Pagado' };
                                                    const valorPagado = parseFloat(presupuesto.valor_consumido || 0);
                                                    const valorPendiente = parseFloat(presupuesto.saldo_disponible || 0);
                                                    return (
                                                        <tr key={presupuesto.id}>
                                                            <td><strong>{presupuesto.numero_presupuesto}</strong></td>
                                                            <td>{formatearFecha(presupuesto.fecha_creacion)}</td>
                                                            <td className="text-center">
                                                                <strong>${Math.round(parseFloat(presupuesto.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                                            </td>
                                                            <td className="text-center" style={{ color: '#28a745', fontWeight: 700 }}>
                                                                ${Math.round(valorPagado).toLocaleString('es-CO')}
                                                            </td>
                                                            <td className="text-center" style={{ color: valorPendiente > 0 ? '#dc3545' : '#28a745', fontWeight: 700 }}>
                                                                ${Math.round(valorPendiente).toLocaleString('es-CO')}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className={`estado-chip ${
                                                                    estado === 0 ? 'generado'
                                                                    : estado === 1 ? 'activo'
                                                                    : estado === 2 ? 'anulado'
                                                                    : estado === 3 ? 'por-cobrar'
                                                                    : 'generado'
                                                                }`}>
                                                                    {estadoTextos[estado] || 'Desconocido'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light shadow-sm"
                                                                    onClick={() => abrirModalAcciones('presupuesto', presupuesto)}
                                                                    style={{ borderRadius: '8px', padding: '4px 12px', background: 'white', color: '#323a45', border: '1px solid #f0f0f0' }}
                                                                >
                                                                    <i className="fas fa-ellipsis-v"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Paginador Presupuestos */}
                                {presupuestos.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {indicePrimerRegistroPresupuestos + 1} a {Math.min(indiceUltimoRegistroPresupuestos, presupuestos.length)} de {presupuestos.length} presupuestos
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActualPresupuestos === 1 ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaPresupuestos(paginaActualPresupuestos - 1)}
                                                            disabled={paginaActualPresupuestos === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>

                                                    {[...Array(totalPaginasPresupuestos)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        // Mostrar solo 5 páginas a la vez
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginasPresupuestos ||
                                                            (numeroPagina >= paginaActualPresupuestos - 1 && numeroPagina <= paginaActualPresupuestos + 1)
                                                        ) {
                                                            return (
                                                                <li
                                                                    key={numeroPagina}
                                                                    className={`page-item ${paginaActualPresupuestos === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button
                                                                        className="page-link"
                                                                        onClick={() => cambiarPaginaPresupuestos(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActualPresupuestos - 2 ||
                                                            numeroPagina === paginaActualPresupuestos + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}

                                                    <li className={`page-item ${paginaActualPresupuestos === totalPaginasPresupuestos ? 'disabled' : ''}`}>
                                                        <button
                                                            className="page-link"
                                                            onClick={() => cambiarPaginaPresupuestos(paginaActualPresupuestos + 1)}
                                                            disabled={paginaActualPresupuestos === totalPaginasPresupuestos}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal de Acciones Rápidas */}
                {showModalAcciones && registroAccion && (
                    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.5)', zIndex: 9999 }}>
                        <div className="modal-dialog modal-dialog-centered modal-sm">
                            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                                <div className="modal-header border-0 pb-0" style={{ background: '#f8f9fa' }}>
                                    <h6 className="modal-title font-weight-bold" style={{ color: '#323a45' }}>
                                        {tipoAccionSeleccionada === 'factura'
                                            ? `Opciones Factura ${registroAccion.prefijo ? `${registroAccion.prefijo}-` : ''}${registroAccion.numero_factura || `#${registroAccion.id}`}`
                                            : `Opciones Presupuesto N° ${registroAccion.numero_presupuesto}`}
                                    </h6>
                                    <button type="button" className="close" onClick={cerrarModalAcciones}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body p-3">
                                    <div className="list-group list-group-flush">
                                        {tipoAccionSeleccionada === 'factura' ? (
                                            <>
                                                <Link
                                                    to={`/informacion-factura/${registroAccion.id}`}
                                                    className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                    style={{ borderRadius: '12px', background: '#f0f5ff' }}
                                                    onClick={cerrarModalAcciones}
                                                >
                                                    <i className="fas fa-info-circle mr-3" style={{ color: '#17a2b8' }}></i>
                                                    <span style={{ fontWeight: 600 }}>Ver información</span>
                                                </Link>

                                                {registroAccion.estado === 0 && (
                                                    <>
                                                        {tienePermiso('anular_facturas') && (
                                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { anularFactura(registroAccion.id, registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                                <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                            </button>
                                                        )}
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { reenviarFacturaDian(registroAccion.id); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-paper-plane mr-3 text-primary"></i><span style={{ fontWeight: 600 }}>Enviar a DIAN</span>
                                                        </button>
                                                    </>
                                                )}

                                                {registroAccion.estado === 1 && (
                                                    <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirModalNotaCredito(registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                        <i className="fas fa-file-invoice mr-3 text-danger"></i><span style={{ fontWeight: 600 }}>Nota crédito</span>
                                                    </button>
                                                )}

                                                {(registroAccion.estado === 2 || registroAccion.estado === 5) && (
                                                    <>
                                                        <button
                                                            className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2"
                                                            onClick={() => {
                                                                if (registroAccion.estado === 5) abrirModalNotaCreditoNoElectronica(registroAccion);
                                                                else abrirModalNotaCredito(registroAccion);
                                                                cerrarModalAcciones();
                                                            }}
                                                            style={{ borderRadius: '12px' }}
                                                        >
                                                            <i className="fas fa-file-invoice-dollar mr-3 text-danger"></i><span style={{ fontWeight: 600 }}>Nota crédito</span>
                                                        </button>
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { abrirModalRecibo(registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-money-bill-wave mr-3 text-success"></i><span style={{ fontWeight: 600 }}>Registrar abono</span>
                                                        </button>
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { verRecibos(registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-receipt mr-3 text-info"></i><span style={{ fontWeight: 600 }}>Ver abonos</span>
                                                        </button>
                                                    </>
                                                )}

                                                {registroAccion.estado === 4 && tienePermiso('anular_facturas') && (
                                                    <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { anularFactura(registroAccion.id, registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                        <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                    </button>
                                                )}

                                                {registroAccion.estado === 6 && (
                                                    <>
                                                        {tienePermiso('anular_facturas') && (
                                                            <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { anularFactura(registroAccion.id, registroAccion); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                                <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                            </button>
                                                        )}
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { reenviarFacturaDian(registroAccion.id); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-redo mr-3 text-primary"></i><span style={{ fontWeight: 600 }}>Reenviar a DIAN</span>
                                                        </button>
                                                    </>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { vistaPreviaPresupuesto(registroAccion.id); cerrarModalAcciones(); }} style={{ borderRadius: '12px', background: '#f0f5ff' }}>
                                                    <i className="fas fa-eye mr-3 text-info"></i><span style={{ fontWeight: 600 }}>Vista previa</span>
                                                </button>
                                                {parseInt(registroAccion.estado) === 0 && (
                                                    <>
                                                        <Link to={`/editar-presupuesto/${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                            <i className="fas fa-edit mr-3 text-warning"></i><span style={{ fontWeight: 600 }}>Editar</span>
                                                        </Link>
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" onClick={() => { cambiarEstadoPresupuesto(registroAccion.id, 1); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-check-circle mr-3 text-success"></i><span style={{ fontWeight: 600 }}>Aprobar</span>
                                                        </button>
                                                    </>
                                                )}
                                                {parseInt(registroAccion.estado) === 1 && (
                                                    <>
                                                        <Link to={`/editar-presupuesto/${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                            <i className="fas fa-edit mr-3 text-warning"></i><span style={{ fontWeight: 600 }}>Editar</span>
                                                        </Link>
                                                        {parseFloat(registroAccion.saldo_disponible || 0) > 0 && (
                                                            <>
                                                                <Link to={`/crear-factura?presupuesto_activo=${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                                    <i className="fas fa-file-invoice-dollar mr-3 text-success"></i><span style={{ fontWeight: 600 }}>Factura electrónica</span>
                                                                </Link>
                                                                <Link to={`/crear-factura-no-electronica?presupuesto_activo=${registroAccion.id}`} className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2" style={{ borderRadius: '12px' }} onClick={cerrarModalAcciones}>
                                                                    <i className="fas fa-receipt mr-3 text-secondary"></i><span style={{ fontWeight: 600 }}>Factura no electrónica</span>
                                                                </Link>
                                                            </>
                                                        )}
                                                        <button className="list-group-item list-group-item-action border-0 d-flex align-items-center mb-2 text-danger" onClick={() => { cambiarEstadoPresupuesto(registroAccion.id, 2); cerrarModalAcciones(); }} style={{ borderRadius: '12px' }}>
                                                            <i className="fas fa-ban mr-3"></i><span style={{ fontWeight: 600 }}>Anular</span>
                                                        </button>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Recibo de Caja */}
                {showModalRecibo && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Registrar Abono</h4>
                                    <button type="button" className="close" onClick={() => setShowModalRecibo(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-light border py-2 mb-3">
                                        <div className="mb-1"><strong>Factura N°</strong> {facturaSeleccionada?.numero_factura || '—'}</div>
                                        <div className="mb-0 small text-muted">
                                            Saldo pendiente (informativo):{' '}
                                            <strong className="text-dark">${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Paciente:</label>
                                        <input type="text" className="form-control" value={getNombreCompleto()} readOnly />
                                    </div>
                                    <div className="form-group">
                                        <label>Valor a Recibir *:</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" title="Pesos colombianos">
                                                    <i className="fas fa-dollar-sign" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={valorRecibo}
                                                onChange={(e) => setValorRecibo(e.target.value)}
                                                step="0.01"
                                                min="0.01"
                                                max={facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0}
                                            />
                                        </div>
                                        <small className="text-muted">
                                            Máximo: ${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}
                                        </small>
                                    </div>
                                    <div className="form-group">
                                        <label>Fecha de Pago *:</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={fechaPago}
                                            onChange={(e) => setFechaPago(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Medio de Pago *:</label>
                                        <select
                                            className="form-control"
                                            value={medioPago}
                                            onChange={(e) => setMedioPago(e.target.value)}
                                        >
                                            <option value="10">Efectivo</option>
                                            <option value="42">Consignación bancaria</option>
                                            <option value="1">Instrumento no definido</option>
                                            <option value="20">Cheque</option>
                                            <option value="30">Transferencia Crédito</option>
                                            <option value="31">Transferencia Débito</option>
                                            <option value="45">Transferencia Crédito Bancario</option>
                                            <option value="47">Transferencia Débito Bancaria</option>
                                            <option value="48">Tarjeta Crédito</option>
                                            <option value="49">Tarjeta Débito</option>
                                            <option value="ZZZ">Acuerdo mutuo</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Observaciones:</label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            value={observacionesRecibo}
                                            onChange={(e) => setObservacionesRecibo(e.target.value)}
                                            placeholder="Observaciones del recibo..."
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalRecibo(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-info" onClick={guardarRecibo}>Guardar Recibo</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Ver Recibos */}
                {showModalRecibos && (
                    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title">Recibos de Caja - Factura N° {facturaSeleccionada?.numero_factura}</h4>
                                    <button type="button" className="close" onClick={() => setShowModalRecibos(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>N° Recibo</th>
                                                    <th>Fecha Pago</th>
                                                    <th>Valor</th>
                                                    <th>Medio Pago</th>
                                                    <th>Estado</th>
                                                    <th>Observaciones</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {recibosFactura.map(recibo => (
                                                    <tr key={recibo.id}>
                                                        <td>{recibo.numero_recibo}</td>
                                                        <td>{formatearFecha(recibo.fecha_pago)}</td>
                                                        <td className="text-right">
                                                            <strong>${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</strong>
                                                        </td>
                                                        <td>{getMedioPagoTexto(recibo.forma_pago)}</td>
                                                        <td className="text-center">
                                                            <span className={`badge ${recibo.estado === 0 ? 'badge-danger' : 'badge-success'}`}>
                                                                {recibo.estado === 0 ? 'Anulado' : 'Activo'}
                                                            </span>
                                                        </td>
                                                        <td>{recibo.observaciones || '-'}</td>
                                                        <td className="text-center">
                                                            {recibo.estado === 1 && (
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => anularRecibo(recibo.id)}
                                                                    title="Anular Recibo"
                                                                >
                                                                    <i className="fas fa-ban"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {recibosFactura.length === 0 && (
                                            <div className="text-center p-4">
                                                <p>No hay recibos registrados para esta factura.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalRecibos(false)}>Cerrar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito Electrónica */}
                {showModalNotaCredito && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header bg-danger text-white">
                                    <h4 className="modal-title">
                                        <i className="fas fa-file-invoice"></i> Generar Nota Crédito Electrónica
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalNotaCredito(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-info">
                                        <strong>Factura:</strong> {facturaSeleccionada?.numero_factura}<br />
                                        <strong>Paciente:</strong> {getNombreCompleto()}<br />
                                        <strong>Saldo Pendiente:</strong> ${Math.round(parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total || 0)).toLocaleString('es-CO')}
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo *</label>
                                                <select
                                                    className="form-control"
                                                    value={prefijoSeleccionado}
                                                    onChange={handlePrefijoChange}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {prefijos.map(prefijo => (
                                                        <option key={prefijo.id} value={prefijo.id}>
                                                            {prefijo.prefijo}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota Crédito *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={numeroNotaCredito}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Nota Crédito *</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={fechaNotaCredito}
                                                    onChange={(e) => setFechaNotaCredito(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Tipo de Nota Crédito *</label>
                                                <select
                                                    className="form-control"
                                                    value={tipoNotaCredito}
                                                    onChange={(e) => {
                                                        const nuevoTipo = e.target.value;
                                                        setTipoNotaCredito(nuevoTipo);
                                                        if (nuevoTipo === 'total') {
                                                            const saldo = parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total);
                                                            setValorNotaCredito(saldo);
                                                        } else {
                                                            setValorNotaCredito('');
                                                        }
                                                    }}
                                                >
                                                    <option value="total">Total (Anular Saldo Restante)</option>
                                                    <option value="parcial">Parcial (Ajuste de Valor)</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor a Acreditar *</label>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={valorNotaCredito}
                                                        onChange={(e) => setValorNotaCredito(e.target.value)}
                                                        readOnly={tipoNotaCredito === 'total'}
                                                        max={facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total}
                                                        required
                                                    />
                                                </div>
                                                {tipoNotaCredito === 'parcial' && (
                                                    <small className="form-text text-muted">Ingresa el valor que deseas descontar del saldo.</small>
                                                )}
                                                {tipoNotaCredito === 'total' && (
                                                    <small className="form-text text-info">Se acreditará el saldo pendiente completo.</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Motivo *</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={motivoNotaCredito}
                                                    onChange={(e) => setMotivoNotaCredito(e.target.value)}
                                                    placeholder="Describa la razón de la nota crédito..."
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCredito(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-primary" onClick={generarNotaCredito}>
                                        <i className="fas fa-paper-plane"></i> Generar y Enviar a DIAN
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Debug - Mostrar respuesta DIAN */}
                {showModalDebug && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className={`modal-header ${debugType === 'success' ? 'bg-success' : debugType === 'json' ? 'bg-primary' : 'bg-danger'} text-white`}>
                                    <h4 className="modal-title">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2"></i>Envío Exitoso</>
                                        ) : debugType === 'json' ? (
                                            <><i className="fas fa-code mr-2"></i>JSON para DIAN</>
                                        ) : (
                                            <><i className="fas fa-exclamation-triangle mr-2"></i>Error en el Envío</>
                                        )}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalDebug(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-check-circle"></i> {debugData?.message}</h5>
                                            </div>
                                            <div className="card border-success">
                                                <div className="card-header bg-success text-white">
                                                    <strong><i className="fas fa-check-circle mr-2"></i>Detalles de la Respuesta</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p><strong>UUID:</strong> <code style={{ fontSize: '0.9em' }}>{debugData?.uuid}</code></p>
                                                    {debugData?.numero_nc ? (
                                                        <>
                                                            <p><strong>Número Nota Crédito:</strong>
                                                                <span className="badge badge-success ml-2">{debugData.numero_nc}</span>
                                                            </p>
                                                            {debugData?.recibos_anulados > 0 && (
                                                                <p><strong>Recibos Anulados:</strong>
                                                                    <span className="badge badge-warning ml-2">{debugData.recibos_anulados}</span>
                                                                </p>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <p><strong>Estado de la Factura:</strong>
                                                            <span className={`badge ml-2 ${debugData?.estado === 1 ? 'badge-success' : 'badge-info'}`}>
                                                                {debugData?.estado === 1 ? 'Cobrada (Contado)' : 'Por Cobrar (Crédito)'}
                                                            </span>
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        className="btn btn-info mr-2"
                                                        onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                                    >
                                                        <i className="fas fa-info-circle"></i> Ver Detalles de Factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="alert alert-danger">
                                                <h5><i className="fas fa-exclamation-triangle"></i> {debugData?.message}</h5>
                                            </div>

                                            {debugData?.response && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-warning">
                                                        <strong><i className="fas fa-exclamation-triangle mr-2"></i>Respuesta de la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}

                                            {debugData?.json_enviado && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-primary text-white">
                                                        <strong><i className="fas fa-code mr-2"></i>JSON Enviado a la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}

                                            {debugData?.facturaId && (
                                                <div className="mt-3">
                                                    <button
                                                        className="btn btn-info mr-2"
                                                        onClick={() => window.location.href = `/#/informacion-factura/${debugData.facturaId}`}
                                                    >
                                                        <i className="fas fa-info-circle"></i> Ver Detalles de Factura
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Nota Crédito No Electrónica */}
                {showModalNotaCreditoNE && consecutivoNCNE && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header bg-danger text-white">
                                    <h5 className="modal-title">
                                        <i className="fas fa-file-invoice-dollar"></i> Generar Nota Crédito
                                    </h5>
                                    <button type="button" className="close text-white" onClick={() => setShowModalNotaCreditoNE(false)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form onSubmit={generarNotaCreditoNE}>
                                    <div className="modal-body">
                                        <div className="alert alert-info py-2">
                                            <small><i className="fas fa-info-circle"></i> <strong>Factura Afectada:</strong> {facturaSeleccionada?.prefijo ? `${facturaSeleccionada.prefijo}-` : ''}{facturaSeleccionada?.numero_factura}</small><br />
                                            <small><i className="fas fa-wallet"></i> <strong>Saldo Pendiente:</strong> ${Math.round(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total).toLocaleString()}</small>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label">Consecutivo:</label>
                                            <div className="col-sm-8">
                                                <input
                                                    type="text"
                                                    className="form-control-plaintext font-weight-bold"
                                                    value={`${consecutivoNCNE.prefijo || ''}-${consecutivoNCNE.consecutivo || ''}`}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>Tipo de Nota</label>
                                            <select
                                                className="form-control"
                                                value={tipoNotaCreditoNE}
                                                onChange={(e) => {
                                                    const nuevoTipo = e.target.value;
                                                    setTipoNotaCreditoNE(nuevoTipo);
                                                    if (nuevoTipo === 'total') {
                                                        const saldo = parseFloat(facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total);
                                                        setValorNotaCreditoNE(saldo);
                                                    }
                                                }}
                                            >
                                                <option value="total">Total (Anular Saldo Restante)</option>
                                                <option value="parcial">Parcial (Ajuste de Valor)</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label>Valor a Acreditar</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">$</span>
                                                </div>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={valorNotaCreditoNE}
                                                    onChange={(e) => setValorNotaCreditoNE(e.target.value)}
                                                    readOnly={tipoNotaCreditoNE === 'total'}
                                                    max={facturaSeleccionada?.valor_pendiente || facturaSeleccionada?.valor_total}
                                                    required
                                                />
                                            </div>
                                            {tipoNotaCreditoNE === 'parcial' && (
                                                <small className="form-text text-muted">Ingresa el valor que deseas descontar del saldo.</small>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Fecha Emisión</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaNotaCreditoNE}
                                                onChange={(e) => setFechaNotaCreditoNE(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Motivo *</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={motivoNotaCreditoNE}
                                                onChange={(e) => setMotivoNotaCreditoNE(e.target.value)}
                                                placeholder="Describa la razón de la nota crédito..."
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowModalNotaCreditoNE(false)}>Cancelar</button>
                                        <button type="submit" className="btn btn-primary" disabled={loadingNCNE}>
                                            {loadingNCNE ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-save"></i>} Generar Nota
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Éxito Recibo */}
                {showModalExitoRecibo && reciboGuardado && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header bg-info text-white">
                                    <h5 className="modal-title">
                                        <i className="fas fa-check-circle"></i> Recibo Registrado Exitosamente
                                    </h5>
                                    <button type="button" className="close text-white" onClick={() => setShowModalExitoRecibo(false)}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="text-center mb-3">
                                        <i className="fas fa-receipt fa-3x text-success mb-3"></i>
                                        <h5>Recibo N° {reciboGuardado.numero_recibo}</h5>
                                        <p className="text-muted mb-1">
                                            Valor: <strong>${Math.round(parseFloat(reciboGuardado.valor_pago || reciboGuardado.valor_recibido || valorRecibo)).toLocaleString('es-CO')}</strong>
                                        </p>
                                        <p className="text-muted">
                                            <small>Factura N° {facturaSeleccionada?.numero_factura}</small>
                                        </p>
                                    </div>
                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle"></i> El recibo ha sido registrado correctamente en el sistema.
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalExitoRecibo(false)}>
                                        Cerrar
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() => {
                                            vistaPreviaRecibo(reciboGuardado);
                                        }}
                                    >
                                        <i className="fas fa-file-pdf"></i> Ver PDF
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                            vistaPreviaRecibo(reciboGuardado);
                                            setShowModalExitoRecibo(false);
                                        }}
                                    >
                                        <i className="fas fa-print"></i> Imprimir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default EstadoCuentaPaciente;
